<template>
    <c-dialog ref="dialog" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <m-search ref="search" @search="searchHandle">
            <m-search-item label="记录单号">
                <c-input name="record_number"></c-input>
            </m-search-item>
            <m-search-item label="收支类型">
                <c-select name="income_expenses" :options="INCOME_EXPENSES"></c-select>
            </m-search-item>
            <m-search-item label="业务单号">
                <c-input name="docket_number"></c-input>
            </m-search-item>
            <m-search-item label="账单类型">
                <c-input name="trans_type"></c-input>
            </m-search-item>

            <m-search-item label="记录时间" colspan="2">
                <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
            </m-search-item>
        </m-search>

        <c-table ref="recordList">
            <c-table-column
                    label="记录单号"
                    name="record_number"
                    width="165"
            >
            </c-table-column>

            <c-table-column
                    label="收支状态"
                    name="audit_state"
                    width="90"
            >
                <template #default="{data}">
                    <c-state async dict="TRANS_STATE" :value="data.trans_state"></c-state>
                </template>
            </c-table-column>

            <c-table-column
                    name="income_expenses"
                    label="收支类型"
                    width="90"
            >
                <template #default="{data}">
                    <c-state  async dict="INCOME_EXPENSES" :value="data.income_expenses"></c-state>
                </template>
            </c-table-column>

            <c-table-column
                    label="收支金额"
                    name="money"
                    width="90"
            >
                <template #default="{data}">
                    ￥{{data.money}}
                </template>
            </c-table-column>

            <c-table-column
                    label="变更后余额"
                    name="surplus_money"
                    width="90"
            >
                <template #default="{data}">
                    ￥{{data.surplus_money}}
                </template>
            </c-table-column>

            <c-table-column
                    label="业务单号"
                    name="docket_number"
                    width="140"
            >
            </c-table-column>

            <c-table-column
                    label="账单类型"
                    name="trans_type"
                    width="140"
            >
            </c-table-column>

            <c-table-column
                    label="记录时间"
                    name="create_date"
                    width="140"
            >
            </c-table-column>

            <c-table-column
                    label="备注"
                    name="remark"
                    width="500"
            >
            </c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>

import {mapState} from "vuex";
import {asyncMapState} from '@/store'

export default {
    name: 'accountRecordList',


    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo']),

        ...asyncMapState(['INCOME_EXPENSES'])
    },

    props: {

    },

    data() {
        return {
            account_type: 1,//账户类型：1=通联余额账户；2=三方余额
            user_type:0,//收支人类型：1=商家主账号 2=商家子账号 3=平台会员
            user_id:0 //收支人ID
        }
    },

    methods: {
        /********搜索************/
        searchHandle(data){
            if (!data){
                data = {};
            }
            data.account_type = this.account_type||1;
            data.user_id = this.user_id || 0;
            data.user_type = this.user_type;
            this.$refs.recordList.load({
                url: '/account/record/list',
                data
            });
        },
        open(data) {
            this.account_type = data.account_type||1;
            this.user_id = data.user_id || 0;
            this.user_type = data.user_type || 0;
            this.searchHandle();
            this.$refs.dialog.open({
                title: data.title
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
    .logs-list {
        padding: 10px 10px;

        li {
            padding: 4px 0;
            line-height: 16px;
            font-size: 13px;
            color: #666;
        }
    }
</style>